import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[border-top]',
})
export class BorderTopDirective {
  @HostBinding('class') elClass = 'border-top';
}
